import {
    GET_TOTAL_REPORTS,
    SET_DATE_FROM,
    SET_DATE_TO,
    GET_USERNAMES,
    SET_UID,
    FILTER_WORKSHEET_STATUS,
    GET_REPORT_TITLES,
    SET_REPORT_TYPE,
    GET_JOBPACKS,
    SET_JOB_ID,
    SET_SELECTED_ROW
} from "./types";

const INITIAL_STATE = {
    requestingWorksheets: false,
    totalUserReports: false,
    dateFrom: false,
    dateTo: false,
    requestingUsers: false,
    totalUsers: false,
    reportUid: false,
    filterWorksheetStatus: false,
    reportType: false,
    reportTitles: [],
    jobPacks: false,
    reportJobID: false,
    selectedRowIndex: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_TOTAL_REPORTS.REQUEST: {
            return {
                ...state,
                requestingWorksheets: true,
                totalUserReports: false
            };
        }
        case GET_TOTAL_REPORTS.FAIL: {
            return {
                ...state,
                requestingWorksheets: false,
                totalUserReports: false
            };
        }
        case GET_TOTAL_REPORTS.SUCCESS: {
            return {
                ...state,
                requestingWorksheets: false,
                totalUserReports: action.payload
            };
        }
        case SET_DATE_FROM: {
            return { ...state, dateFrom: action.payload };
        }
        case SET_DATE_TO: {
            return { ...state, dateTo: action.payload };
        }
        case GET_USERNAMES.REQUEST: {
            return { ...state, requestingUsers: true };
        }
        case GET_USERNAMES.SUCCESS: {
            return {
                ...state,
                requestingUsers: false,
                totalUsers: action.payload
            };
        }
        case GET_USERNAMES.FAIL: {
            return { ...state, requestingUsers: false };
        }
        case SET_UID: {
            return { ...state, reportUid: action.payload };
        }
        case FILTER_WORKSHEET_STATUS: {
            return { ...state, filterWorksheetStatus: action.payload };
        }
        case GET_REPORT_TITLES.REQUEST: {
            return { ...state, requesting: true, reportTitles: false };
        }
        case GET_REPORT_TITLES.SUCCESS: {
            return {
                ...state,
                requesting: false,
                reportTitles: action.payload
            };
        }
        case GET_REPORT_TITLES.FAIL: {
            return { ...state, requesting: false, reportTitles: false };
        }
        case SET_REPORT_TYPE: {
            return {
                ...state,
                reportType: action.payload
            };
        }
        case GET_JOBPACKS.REQUEST: {
            return {
                ...state,
                requestingWorksheets: true,
                jobPacks: false
            };
        }
        case GET_JOBPACKS.FAIL: {
            return {
                ...state,
                requestingWorksheets: false,
                jobPacks: false
            };
        }
        case GET_JOBPACKS.SUCCESS: {
            return {
                ...state,
                requestingWorksheets: false,
                jobPacks: action.payload
            };
        }
        case SET_JOB_ID: {
            return { ...state, reportJobID: action.payload };
        }
        case SET_SELECTED_ROW: {
            return { ...state, selectedRowIndex: action.payload };
        }
        default: {
            return state;
        }
    }
};
